"use strict";

var seed = 0;
module.exports = function guid() {
  return Date.now() + "_" + seed++;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-menu/~/rc-util/lib/guid.js
 ** module id = 591
 ** module chunks = 0
 **/